<template>
    <guest-layout>
        <loading-block v-if="loading" />
        <div class="wrap-login" v-else>
            <h3 class="font-weight-bold text-uppercase">Reset Password</h3>
            <div v-if="valid">
                <div class="form-group">
                    <input type="password" v-model="form.password" v-bind:class="errors.hasOwnProperty('password') ? 'is-invalid' : ''" class="form-control custom-input" placeholder="Password">
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('password')">
                        {{ errors['password'][0] }}
                    </div>
                </div>
                <div class="form-group">
                    <input type="password" v-model="form.password_confirmation" v-bind:class="errors.hasOwnProperty('password_confirmation') ? 'is-invalid' : ''" class="form-control custom-input" placeholder="Konfirmasi Password">
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('password_confirmation')">
                        {{ errors['password_confirmation'][0] }}
                    </div>
                </div>
                <button class="btn btn-primary main-button register-button" @click="handleSubmit">Simpan</button>
            </div>
            <div v-else>
                <h3>Invalid</h3>
            </div>
            <div class="text-center mt-3">
                <p>Belum memiliki akun suara.com? <br>
                    <router-link :to="{ name: 'register' }" class="font-weight-bold text-dark">Daftar Akun</router-link></p>
            </div>
        </div>
    </guest-layout>
</template>
<script>
import axios from "axios";

export default {
    data() {
        return {
            valid: false,
            loading: true,
            errors: [],
            form: {
                password: '',
                password_confirmation: ''
            },
        }
    },
    mounted() {
        this.verification()
    },
    methods: {
        verification() {
            const form = this.$route.query;
            axios.post('/api/lost-password/check', form)
                .then((response) => {
                    this.valid = true
                    this.loading = false
                })
                .catch((error) => {
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                        this.$router.push({name: 'lost-password'});
                    }
                });
        },
        async handleSubmit() {
            const form = this.$route.query;
            let data = {
                ...form,
                ...this.form
            };
            this.loading = true;
            this.errors = [];
            await axios.post('/api/lost-password/reset', data)
                .then((response) => {
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    })
                    this.$router.push({name: 'login'});
                })
                .catch((error) => {
                    this.loading = false;
                    if(error.response) {
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors
                        }
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                    }
                });
        }
    }
}
</script>
<style>
.wrap-login {
    padding: 4%;
    margin-top: 15px;
}
</style>
